var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"id":"map","space":"0"}},[_c('vue-friendly-iframe',{staticClass:"map-frame",attrs:{"className":"map-frame","src":_vm.url_big}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }